(() => {
  const MANUAL_LABELS = {
    'combo-pack-nicotine-pouches': 'Combo Pack',
    'blueberry-ice-nicotine-pouches': 'Blueberry',
    'smoke-free-pleasure-nicotine-pouches-spearmint': 'Spearmint',
    'mango-ice-nicotine-pouches': 'Mango Ice',
    'strawberry-ice-nicotine-pouches': 'Strawberry',
    'lush-nicotine-pouches': 'Watermelon',
    'freezing-nicotine-pouches': 'Freezing',
    'citrus-ice-nicotine-pouches': 'Citrus',
    'peach-ice-nicotine-pouches': 'Peach Ice',
    'grape-ice-nicotine-pouches': 'Grape Ice'
  };

  function cleanText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function toTitleCase(str) {
    return cleanText(str)
      .toLowerCase()
      .replace(/\b\w/g, (s) => s.toUpperCase());
  }

  function getHandleFromHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/?#]+)/i);

      return match ? match[1] : '';
    } catch (e) {
      return '';
    }
  }

  function labelFromAlt(alt) {
    let text = cleanText(alt);

    if (!text) return '';

    text = text
      .replace(/nicotine pouch(es)?/gi, '')
      .replace(/\s+/g, ' ')
      .trim();

    return toTitleCase(text);
  }

  function labelFromHandle(handle) {
    if (!handle) return '';

    return toTitleCase(
      handle
        .replace(/-nicotine-pouches?/gi, '')
        .replace(/-/g, ' ')
    );
  }

  function getFlavorGroups() {
    return Array.from(
      document.querySelectorAll('.variant-picker__option')
    ).filter((group) => {
      const heading = group.querySelector('p.text-subdued');

      const text = cleanText(
        heading?.textContent
      ).toLowerCase();

      return (
        text === 'flavor:' ||
        text === 'flavor' ||
        text === 'style:' ||
        text === 'style'
      );
    });
  }

  function getLabelText(anchor) {
    const href = anchor.getAttribute('href') || '';
    const handle = getHandleFromHref(href);

    if (handle && MANUAL_LABELS[handle]) {
      return MANUAL_LABELS[handle];
    }

    const img = anchor.querySelector('img');
    const alt = img?.getAttribute('alt') || '';
    const fromAlt = labelFromAlt(alt);

    if (
      fromAlt &&
      !/combo pack/i.test(fromAlt)
    ) {
      return fromAlt;
    }

    return labelFromHandle(handle);
  }

  function enhanceFlavorSwatches() {
    const groups = getFlavorGroups();

    groups.forEach((group) => {
      const wrapper =
        group.querySelector(
          '.variant-picker__option-values'
        );

      if (!wrapper) return;

      wrapper.classList.add(
        'zsy-flavor-grid'
      );

      /*
       * 只处理尚未包装的原始 thumbnail-swatch
       */
      const swatches =
        Array.from(wrapper.children).filter((element) => {
          return element.matches?.(
            'a.thumbnail-swatch'
          );
        });

      swatches.forEach((anchor) => {
        const card =
          document.createElement('div');

        card.className =
          'zsy-flavor-card';

        if (
          anchor.classList.contains(
            'is-selected'
          )
        ) {
          card.classList.add(
            'is-selected'
          );
        }

        const label =
          document.createElement('span');

        label.className =
          'zsy-flavor-card__label';

        label.textContent =
          getLabelText(anchor);

        wrapper.insertBefore(
          card,
          anchor
        );

        card.appendChild(anchor);
        card.appendChild(label);
      });

      /*
       * 同步当前选中状态
       */
      wrapper
        .querySelectorAll(
          '.zsy-flavor-card'
        )
        .forEach((card) => {
          const anchor =
            card.querySelector(
              'a.thumbnail-swatch'
            );

          if (!anchor) return;

          card.classList.toggle(
            'is-selected',
            anchor.classList.contains(
              'is-selected'
            )
          );
        });
    });
  }

  function initialize() {
    enhanceFlavorSwatches();

    let timer = null;

    const observer =
      new MutationObserver(() => {
        clearTimeout(timer);

        timer = setTimeout(() => {
          enhanceFlavorSwatches();
        }, 80);
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }
})();